module.exports = __webpack_public_path__ + "static/media/user_profile.ea7a9c1e.svg";